import logoDisney from "../../img/logoClients/logoDisney.webp"
import logoParamount from "../../img/logoClients/logoParamount.webp"
import logoFilmerise from "../../img/logoClients/logoFilmerise.webp"
import logoMTV from "../../img/logoClients/logoMTV.webp"
import logoNickelodeon from "../../img/logoClients/logoNickelodeon.webp"
import logoVisualData from "../../img/logoClients/logoVisualData.webp"
import logoRiot from "../../img/logoClients/logoRiot.webp"
import logoA2Filmes from "../../img/logoClients/logoA2Filmes.webp"
import logoBeliane from "../../img/logoClients/logoBeliane.webp"



const clientes = [
    {
        id: 1,
        nome: "Disney",
        alt: "logo Disney",
        img: logoDisney
    },
    {
        id: 2,
        nome: "Paramount",
        alt: "logo Paramount",
        img: logoParamount
    },
    {
        id: 3,
        nome: "MTV",
        alt: "logo MTV",
        img: logoMTV
    },
    {
        id: 4,
        nome: "Nickelodeon",
        alt: "logo Nickelodeon",
        img: logoNickelodeon
    },
    {
        id: 5,
        nome: "Filmerise",
        alt: "logo Filmerise",
        img: logoFilmerise
    },
    {
        id: 6,
        nome: "Visual Data",
        alt: "logo  Visual Data",
        img: logoVisualData
    },
    {
        id: 7,
        nome: "Riot",
        alt: "logo Riot",
        img: logoRiot
    },
    {
        id: 8,
        nome: "A2 Filmes",
        alt: "logo  A2 Filmes",
        img: logoA2Filmes
    },
    {
        id: 9,
        nome: "Beliane",
        alt: "logo Beliane",
        img: logoBeliane
    },
    
    
    
    
    
]


export default clientes